import { Field } from 'formik';
import { Textarea, FormControl, Grid, GridItem } from '@chakra-ui/react';
import ElementInstructions from './components/ElementInstructions';
import ElementHeading from './components/ElementHeading';
import ElementErrorMessage from './components/ElementErrorMessage';
import { transformRSInput } from '../formControllers/Transformation/Utils';
import InputWrapper from './components/InputWrapper';
import { clearResume } from './utils';
import { getUsefulVars } from '../handlers/helpers';

const RSTextarea = ({ qObj, props }) => {

  const uv = getUsefulVars(props);
  const sectionName = uv.stateProps.sectionData.sectionName;
  const sectionIndex = uv.stateProps.sectionData.sectionIndex;
  const jobSeekerData = uv.formikProps.values.jobSeekerData;
  const fieldName = 'jobSeekerData[' + sectionIndex + ']["' + qObj.qid + '"]';


  return (
    <Field name={fieldName} >
      {({ field, form }) => {
        const rJobPosting = props.stateProps.dataToSave.saved.resumes[uv.resumeIndex]['job_posting'];

        if (sectionName === 'job-posting'
          && qObj.qid === 'job-posting'
          && field.value === undefined) {
          field.value = rJobPosting;
        }
        return (
          <FormControl isInvalid={form.errors[qObj.id] && form.touched[qObj.id]}>
            <ElementHeading qObj={qObj} props={props} />
            <ElementInstructions instructions={qObj.instructions} />
              <textarea style={{ border:'1px solid #c4c4c4',borderRadius: '5px',padding:'.3rem', width:'100%', height:'5rem' }}
                onBlur={e =>
                  transformRSInput(e, jobSeekerData, 0, qObj, props)
                }
                {...field}
              >{qObj.placeholder}</textarea>
            <ElementErrorMessage form={form} index={qObj.index} qid={qObj.qid} />
          </FormControl>
        );
      }}
    </Field>
  );
};

export default RSTextarea;
/*

              onBlur={e => {
                if (sectionName === 'parser') {
                  clearResume(e, form, field, props);
                }
              }
              }
              onChange={e => {
                transformRSInput(e, jobSeekerData, index, qObj, props);
              }
              }
 */


/*
  let fieldValue = '';
  if (qObj.qid === 'job_posting' && sectionName=== 'job-posting') {
    if(jobSeekerData[index] === undefined) {
      fieldValue = props.stateProps.dataToSave.saved.resumes[index]['job-posting'][0];
    } else {
      if (jobSeekerData[index][sectionName] === undefined) {
        fieldValue = props.stateProps.dataToSave.saved.resumes[index]['job-posting'][0];
      } else {
        if (jobSeekerData[index][sectionName][0] === undefined) {
          fieldValue = props.stateProps.dataToSave.saved.resumes[index]['job-posting'][0];
        } else {
          if (jobSeekerData[index][sectionName][0][qObj.qid] === undefined) {
            fieldValue = props.stateProps.dataToSave.saved.resumes[index]['job-posting'][0];
          } else {
            fieldValue = jobSeekerData[index][qObj.qid][0]['job_posting'];
          }
        }
      }
    }
  }
  */
/*
if (qObj.qid === 'job_posting') {
    if (!jobSeekerData[index][sectionName] ||
    !jobSeekerData[index][sectionName][0] ||
    jobSeekerData[index][sectionName][0][qObj.qid] === undefined) {
    fieldValue = props.stateProps.dataToSave.saved.resumes[index]['job-posting'];
  }
      fieldValue = props.stateProps.dataToSave.saved.resumes[index]['job-posting'];
    } else {
      fieldValue = jobSeekerData[index][qObj.qid];
    }
  }*/
/*
let fieldValue = (sectionName ==='job-posting' &&
  qObj.qid === 'job_posting' &&
  (jobSeekerData[index][qObj.qid] === undefined )) ? props.stateProps.dataToSave.saved.resumes[index]['job-posting']: jobSeekerData[index][qObj.qid];
fieldValue = jobSeekerData[index][qObj.qid];
*/